import { createSchemaSelectors } from 'ngrx-normalizr';
import { CheckinExercise, checkinExerciseSchema, CheckinQuestion, checkinQuestionSchema } from '../schemas/checkin.schema';

const checkinExerciseSchemaSelectors = createSchemaSelectors<CheckinExercise>(checkinExerciseSchema);
const checkinQuestionSchemaSelectors = createSchemaSelectors<CheckinQuestion>(checkinQuestionSchema);

export const getCheckinExercises = checkinExerciseSchemaSelectors.getEntities;
export const getCheckinQuestions = checkinQuestionSchemaSelectors.getEntities;
